import {ApiUtil} from '../api/ApiUtil'
import {BackendAPI} from '../api/BackendAPI'
import type {GenerateProductListResponse} from '../api/types'
import type {PlanState, ProductsListOptions} from '../reducers/types'
import type {AppDispatch, GetStateFunc} from '../store'
import {ActionUtil} from "./ActionUtil";

/**
 * product related action types.
 */
export enum ProductActionType {
  PRODUCT_LIST_PENDING = 'PRODUCT_LIST_PENDING',
  PRODUCT_LIST_FULFILLED = 'PRODUCT_LIST_FULFILLED',
  PRODUCT_LIST_REJECTED = 'PRODUCT_LIST_REJECTED'
}

interface FetchProductsAction {
  type: ProductActionType.PRODUCT_LIST_PENDING
}

interface FetchProductsSuccessAction {
  type: ProductActionType.PRODUCT_LIST_FULFILLED
  payload: ProductsListOptions
}

interface FetchProductsFailureAction {
  type: ProductActionType.PRODUCT_LIST_REJECTED
  payload: {
    error: string
  }
}

export type ProductAction =
  | FetchProductsAction
  | FetchProductsSuccessAction
  | FetchProductsFailureAction

export function generateProductList() {
  return async (dispatch: AppDispatch, getState: GetStateFunc): Promise<void> => {
    const token = ActionUtil.getToken(getState, 'generateProductList')
    if (!token) {
      return
    }

    dispatch<ProductAction>({type: ProductActionType.PRODUCT_LIST_PENDING})

    const plan: PlanState = getState().plan
    const productListRes = await BackendAPI.generateProductList(plan, token)
    if (productListRes.succeeded) {
      dispatch<ProductAction>(productListGenerated(productListRes.payload))
    } else {
      const errMsg = ApiUtil.resolveLocalizedErrorMessage(productListRes)
      dispatch<ProductAction>(productListGenerationFailed(errMsg))
    }
  }
}

/* Helper Functions */

function productListGenerated(response: GenerateProductListResponse): ProductAction {
  return {type: ProductActionType.PRODUCT_LIST_FULFILLED, payload: response}
}

function productListGenerationFailed(error: string): ProductAction {
  return {type: ProductActionType.PRODUCT_LIST_REJECTED, payload: {error}}
}
